export const analyticsEventNames = {
  // — Acquisition / intent (CTA clicks, form submits) —
  clickSignup: 'click_signup',
  clickRequestDemo: 'click_request_demo',
  clickSubscr: 'click_subscr',
  clickPilotProgram: 'click_pilot_program',
  clickTelegram: 'click_telegram',
  clickX: 'click_x',
  submitContactForm: 'submit_contact_form',
  submitDemoRequest: 'submit_demo_request',
  // — Laplace x GTM instant demo (URL → leads, before signup) —
  gtmDemoSubmit: 'gtm_demo_submit',
  gtmDemoStarted: 'gtm_demo_started',
  gtmResultsViewed: 'gtm_results_viewed',
  beginCheckout: 'begin_checkout',
  gtmCheckoutAmountSelected: 'gtm_checkout_amount_selected',
  gtmCheckoutContinue: 'gtm_checkout_continue',
  gtmTestPaymentCompleted: 'gtm_test_payment_completed',
  // GA4 recommended event; only for payments confirmed by a live provider.
  purchase: 'purchase',
  gtmWorkspaceActivated: 'gtm_workspace_activated',
  gtmProjectCreated: 'gtm_project_created',
  gtmSearchStarted: 'gtm_search_started',
  gtmSendRequested: 'gtm_send_requested',
  gtmDemoCompleted: 'gtm_demo_completed',
  gtmDemoFailed: 'gtm_demo_failed',
  clickGtmStartCampaign: 'click_gtm_start_campaign',
  // — Activation (account + first workspace) —
  // `sign_up` / `login` are GA4 recommended event names for richer reporting.
  signUp: 'sign_up',
  login: 'login',
  logout: 'logout',
  workspaceCreated: 'workspace_created',
  // — Engagement (core product usage + team growth) —
  chatStarted: 'chat_started',
  messageSent: 'message_sent',
  firstMessageSent: 'first_message_sent',
  inviteAccepted: 'invite_accepted',
} as const

export type AnalyticsEventName =
  (typeof analyticsEventNames)[keyof typeof analyticsEventNames]

export type AnalyticsEventParams = Record<
  string,
  string | number | boolean | null
>
